import { alpha, ButtonBase, Typography } from "@mui/material";
import { useState } from "react";
import { lineSelectionKeeperProps } from "../utils/lineSelection.ts";
import type { AddToSource } from "../utils/statementRowsArea.ts";
import { getAddToTargets } from "../utils/statementRowsArea.ts";
import AddToMenu from "./AddToMenu.tsx";

interface Props {
  source: AddToSource;
}

const AddToChip = ({ source }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const targets = getAddToTargets(source);
  if (targets.length === 0) {
    return null;
  }

  return (
    <>
      <ButtonBase
        {...lineSelectionKeeperProps}
        className="row-actions"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        style={anchorEl ? { visibility: "visible" } : undefined}
        sx={(theme) => ({
          flexShrink: 0,
          px: 0.5,
          py: 0.25,
          borderRadius: "2px",
          color: "text.secondary",
          "&:hover": { bgcolor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity) },
        })}
      >
        <Typography variant="caption">Add</Typography>
      </ButtonBase>
      {anchorEl && (
        <AddToMenu anchorEl={anchorEl} source={source} targets={targets} onClose={() => setAnchorEl(undefined)} />
      )}
    </>
  );
};

export default AddToChip;
